import React from 'react';
import { palettes, Input } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';

import i18next from 'core/i18n';

interface TextSearchInputProps {
  searchText: string;
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCancelSearch: () => void;
}

const StyledInput = styled(Input)`
  margin: 0px;
  width: 350px;
  input {
    padding-right: 20px;
  }
`;

export const TextSearchInput: React.FunctionComponent<TextSearchInputProps> = ({
  searchText,
  handleSearch,
  handleCancelSearch,
  ...rest
}) => {
  return (
    <div style={{ position: 'relative' }}>
      <FontAwesomeIcon
        icon={!searchText ? faSearch : faTimes}
        onClick={!!searchText ? handleCancelSearch : undefined}
        style={{
          position: 'absolute',
          right: 10,
          top: 8,
          zIndex: 10,
          color: palettes.brand.blue.base,
          cursor: !!searchText ? 'pointer' : 'default'
        }}
      />
      <StyledInput
        label={i18next.t('search')}
        hideLabel
        placeholder={i18next.t('search')}
        onChange={handleSearch}
        sizeVariant="slim"
        value={searchText}
        data-test={rest['data-test']}
      />
    </div>
  );
};
